/**
 * Detects and groups "Unexpected number" syntax errors thrown in Chrome that we are currently
 * guessing is a Chrome extension because it occurs in the HTML source and not in our code.
 *
 * @param {object} report the Report Object
 * @returns {boolean} Returns true if the report matches
 * @example
 *    "Unexpected number" when using Chrome
 */
function unexpectedNumberError(report) {
  if (report.errorMessage.includes("Unexpected number") && navigator.userAgent.includes("Chrome")) {
    report.groupingHash = "UnexpectedNumberError";

    return true;
  }

  return false;
}

export default unexpectedNumberError;
